module.exports = require("@swa-ui/itinerary/src/AutocompleteStations/AutocompleteStations.module.scss");